<div class="address-form" [formGroup]="form">
  <div
    class="country-search-group gap-12"
    [class]="{ 'international-address': useInternationalAddresses && !expandedAddressForm, readonly }"
  >
    <div [hidden]="!useInternationalAddresses">
      <app-flags-autocomplete
        formControlName="country"
        [label]="addressFormLabels.country"
        [switchBtnText]="useInternationalAddresses && expandedAddressForm ? 'Find Address' : ''"
        [readonly]="readonly"
        (switchBtnClick)="switchAddressForm()"
      />
    </div>

    <div class="flex-grow-1" [hidden]="expandedAddressForm">
      <app-address-autocomplete
        class="d-block"
        placeholder="Type Address"
        formControlName="normalizedFullAddress"
        [label]="label || addressFormLabels.normalizedFullAddress"
        [clearStatusAfter]="5000"
        [isDisabled]="isDisabled"
        [isValidating]="isValidating()"
        [isAustraliaSelected]="isAustraliaSelected()"
        [useInternationalAddresses]="useInternationalAddresses"
        [hideWarningMessage]="hideWarningMessage"
        [country]="form.value.country ?? ''"
        [readonly]="readonly"
        (input)="onTypingAddress($event.target?.['value'] ?? '')"
        (focus)="onFocusSearchControl()"
        (blur)="onBlurAddressSearch()"
        (tryParse)="parseWithNormalisedFullAddress()"
        (onSelect)="parseAddress($event)"
        (onTextChange)="textChange($event)"
        (dataStatusChange)="dataStatusChange($event)"
        (switchBtnClick)="switchAddressForm()"
        (searchUpdate)="setIsSearching($event)"
        [suggestedAddresses]="suggestedAddresses"
        [(dataStatus)]="addressStatus"
      />
    </div>
  </div>

  <div [hidden]="!expandedAddressForm">
    @if (addressStatus === AddressStatus.WARNING && !hideWarningMessage) {
      <div class="warning-message mt-2">
        <i class="icon ic-info-circle-16"></i>
        <span>Address was not validated and most likely to be rejected</span>
      </div>
    }

    <div class="mt-2">
      <app-input
        formControlName="street"
        placeholder="Type Address"
        [label]="addressFormLabels.street"
        [isDisabled]="isDisabled"
        [switchBtnText]="useInternationalAddresses ? '' : 'Find Address'"
        (switchBtnClick)="switchAddressForm()"
      />
    </div>

    <div class="mt-2">
      <app-input
        formControlName="line2"
        placeholder="Type level, unit or shop number"
        [switchBtnText]="careOfAllowed ? 'Care Of' : ''"
        (switchBtnClick)="isCareOfVisible = !isCareOfVisible"
        [label]="addressFormLabels.line2"
        [isDisabled]="isDisabled"
      />
    </div>

    <div class="mt-2 form-group" [hidden]="!careOfAllowed || !isCareOfVisible">
      <app-input
        class="d-block mt-2"
        formControlName="careOf"
        [label]="addressFormLabels.careOf"
        [isDisabled]="isDisabled"
      ></app-input>
    </div>

    <div class="suburb-state-postcode-group gap-12" [class.active]="isAustraliaSelected()">
      @if (isAustraliaSelected()) {
        <div class="mt-2">
          <app-suburbs-autocomplete
            formControlName="suburb"
            (selectSuburb)="selectSuburb($event)"
          />
        </div>
      } @else {
        <div class="mt-2">
          <app-input
            class="d-block mt-2"
            formControlName="suburb"
            placeholder="Type Suburb"
            [label]="isAustraliaSelected() ? 'Suburb' : 'City or Locality'"
            [isDisabled]="isDisabled"
          />
        </div>

        <div class="mt-2">
          <app-input
            class="d-block mt-2"
            formControlName="region"
            placeholder="Region"
            [label]="addressFormLabels.region"
            [isDisabled]="isDisabled"
          />
        </div>
      }

      <div class="mt-2">
        <app-flags-autocomplete
          formControlName="state"
          placeholder="Select State"
          [label]="addressFormLabels.state"
          [options]="stateOptions"
          [hidden]="useInternationalAddresses && !isAustraliaSelected()"
          [isDisabled]="isDisabled"
        />
      </div>

      <div class="mt-2">
        <app-input
          formControlName="postcode"
          placeholder="Type Postcode"
          [label]="addressFormLabels.postcode"
          [isDisabled]="isDisabled"
        />
      </div>
    </div>
  </div>
</div>
